import { Action, combineReducers, Reducer } from "redux";
import { createReducer, PayloadAction } from "typesafe-actions";
import { ActivePhonesData } from "@sms/shared/active-phones/active-phones.interface";

import { setActivePhonesAction } from "./active-phones.actions";

export interface ActivePhonesStore {
  activePhones: ActivePhonesData[];
}

export const activePhonesReducer: Reducer<ActivePhonesStore> = combineReducers({
  activePhones: createReducer<ActivePhonesData[], Action>([]).handleAction(
    setActivePhonesAction,
    (_: ActivePhonesData[], { payload }: PayloadAction<string, ActivePhonesData[]>) => payload
  )
});
